import { Injectable } from "@angular/core";
import {
    LOCAL_STORAGE_CURRENT_LANG,
    LOCAL_STORAGE_INFO_PLANT_USER,
    LOCAL_STORAGE_LOGGED_EMAIL,
    LOCAL_STORAGE_LOGGED_USER_ID,
    LOCAL_STORAGE_REFRESH_TOKEN,
    LOCAL_STORAGE_TOKEN
} from "../../crossconcern/utilities/properties/localstorage.property";
import { LocalStorageRepositoryInterface } from "./localstorage.interface";

@Injectable()
export class LocalStorageRepository implements LocalStorageRepositoryInterface {

    public getToken(): string {
        return localStorage.getItem(LOCAL_STORAGE_TOKEN);
    }

    public setToken(value: string): void {
        localStorage.setItem(LOCAL_STORAGE_TOKEN, value);
    }

    public removeToken(): void {
        localStorage.removeItem(LOCAL_STORAGE_TOKEN);
    }

    public getRefreshToken(): string {
        return localStorage.getItem(LOCAL_STORAGE_REFRESH_TOKEN);
    }

    public setRefreshToken(value: string) {
        localStorage.setItem(LOCAL_STORAGE_REFRESH_TOKEN, value);
    }

    public removeRefreshToken() {
        localStorage.removeItem(LOCAL_STORAGE_REFRESH_TOKEN);
    }

    public getLoggedEmail(): string {
        return localStorage.getItem(LOCAL_STORAGE_LOGGED_EMAIL);
    }

    public removeLoggedEmail() {
        localStorage.removeItem(LOCAL_STORAGE_LOGGED_EMAIL);
    }

    public setLoggedEmail(value: string) {
        localStorage.setItem(LOCAL_STORAGE_LOGGED_EMAIL, value);
    }

    public getLoggedUserId(): string {
        return localStorage.getItem(LOCAL_STORAGE_LOGGED_USER_ID);
    }

    public removeLoggedUserId() {
        localStorage.removeItem(LOCAL_STORAGE_LOGGED_USER_ID);
    }

    public setLoggedUserId(value: string) {
        localStorage.setItem(LOCAL_STORAGE_LOGGED_USER_ID, value);
    }

    public getInfoPlantToken() {
        return localStorage.getItem(LOCAL_STORAGE_INFO_PLANT_USER);
    }

    public setInfoPlantToken(value: string) {
        localStorage.setItem(LOCAL_STORAGE_INFO_PLANT_USER, value);
    }

    public removeInfoPlantToken() {
        localStorage.removeItem(LOCAL_STORAGE_INFO_PLANT_USER);
    }

    public getCurrentLanguage() {
        return localStorage.getItem(LOCAL_STORAGE_CURRENT_LANG);
    }

    public setCurrentLanguage(value: string) {
        localStorage.setItem(LOCAL_STORAGE_CURRENT_LANG, value);
    }

    public removeCurrentLanguage() {
        localStorage.removeItem(LOCAL_STORAGE_CURRENT_LANG);
    }

}
